<div class="show-room">
    <div class="show-item" *ngFor="let item of showItem" (click)="route(item)">
        <i class="material-icons" style="font-size:100px">{{item.icon}}</i> {{item.name}}
    </div>
</div>